import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// context
import { useSearchBar } from "core/SearchBar/context/useSearchBar.js";

// components
import StyleHiddenInputs from "./StyleHiddenInputs";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";

const FormStyled = styled.form`
    background-color: ${colors.primary.snow};
    display: flex;
    align-items: center;
    height: ${convertPxToRem(40)};
`;

// component
export const Form = ({ children, className }) => {
    const {
        inputValue,
        dropDown: {
            selectedOption: { searchParamKey },
        },
    } = useSearchBar();

    // Note: rather than
    //  - disabling the search button until the user enters text in the input
    //  - disable the form and let them know the input is required
    // we chose to refresh the page (following Amazon's search bar lead)
    const onSubmit = e => {
        if (!inputValue.trim()) {
            e.preventDefault();
            window.location.reload();
        }
    };

    return (
        <FormStyled
            className={className}
            method="GET"
            action={`/search/${searchParamKey}/`}
            onSubmit={onSubmit}
        >
            <StyleHiddenInputs />
            {children}
        </FormStyled>
    );
};

export default Form;

// prop-types
Form.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
};
